export const getAddressLabel = (address: any, index: number) => {
    if (address.property_type === null || address.property_type === undefined || address.property_type === '') {
      return `${address.number || ''} ${address.street === '' || address.street === null ? address.property_name || '' : address.street || ''}, ${address.plantation || ''}<span style="display:none;">${index}</span>`;
    }
    
    switch (address.property_type.toString()) {
      case '0':
        return `${address.number || ''} ${address.street || ''}, ${address.plantation || ''}${address.property_name? ` - ${address.property_name}` :''}<span style="display:none;">${index}</span>`;
      case '1':
        return `${address.number || ''} ${address.street === '' || address.street === null ? address.property_name || '' : address.street || ''}, ${address.plantation || ''}<span style="display:none;">${index}</span>`;
      default:
        return '';
    }
};
